export default __webpack_public_path__ + "static/media/stayfi.8e89626f.png";